// *******************************************************************************
// Form : Step Form
// *******************************************************************************

const handleStepForm = (form, formAction, id) => {
  const formParent = form.closest('[data-step-form-parent]');
  const allSteps = formParent.querySelectorAll('[data-step-form-step]');
  const allFormSteps = formParent.querySelectorAll('.step-form__step');
  const allStepIndicator = formParent.querySelectorAll('.step-form__indicator-btn');
  const nextButton = formParent.querySelector('.step-form__next-step');
  const submitButtonText = nextButton.getAttribute(['data-submit-text']);
  const formAlertError = formParent.querySelector('.step-form__alert-error');
  const nextButtonText = nextButton.innerHTML;
  const allForms = [];
  const allStepData = [];

  let currentStepIndex = 0;

  const toggleStep = (index, active) => {
    const step = allFormSteps[index];
    const stepIndicator = allStepIndicator[index];

    FormValidation.utils.classSet(step, {
      'is-active': active,
    });
    FormValidation.utils.classSet(stepIndicator, {
      'is-active': true,
    });
  };

  const markCompleted = (index) => {
    const stepIndicator = allStepIndicator[index];
    stepIndicator.classList.add('is-completed');
  };

  const moveNextStep = async () => {
    if (currentStepIndex < allForms.length) {
      const currentForm = allForms[currentStepIndex];
      const status = await currentForm.validate();
      if (status !== 'Valid' || !extraValidateOtherField('#inquiry-steps-form', currentStepIndex)) {
        return;
      }

      let nextIndex = currentStepIndex + 1;

      while (nextIndex < allFormSteps.length && allFormSteps[nextIndex].classList.contains('hide')) {
        nextIndex++;
      }

      if (nextIndex < allFormSteps.length) {
        toggleStep(currentStepIndex, false);
        currentStepIndex = nextIndex;
        toggleStep(currentStepIndex, true);

        if (currentStepIndex === allFormSteps.length - 1) {
          nextButton.innerHTML = submitButtonText;
        }
      }
    }
  };

  allFormSteps.forEach((step, index) => {
    const fv = FormValidation.formValidation(step, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox,.radio-button,.dropdown'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger({
          event: 'submit',
        }),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        if (e.element.hasAttribute('required')) {
          const value = fv.getElementValue(e.field, e.element);
          const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox,.radio-button,.dropdown');
          FormValidation.utils.classSet(container, {
            'is-validation-failed': value === '' || !e.valid,
          });
        }
      })
      .on('core.form.valid', () => {
        grecaptcha.ready(async () => {
          formParent.classList.add('show-loader');

          try {
            const stepData = getFormValue(step, fv);
            allStepData.push(JSON.parse(stepData.inputs));

            if (index === allFormSteps.length - 1) {
              const inputs = {};

              for (const key in allStepData) {
                if (!isNaN(key)) {
                  Object.assign(inputs, allStepData[key]);
                }
              }

              await onFormSubmit({
                formData: {
                  inputs: JSON.stringify(inputs),
                  lang: localData.lang,
                  id: localData.id,
                },
                recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
                recaptchaAction: formAction,
              });

              sendToDataLayer(id);
            }

            formParent.classList.remove('show-loader');
            if (index === allFormSteps.length - 1) {
              formParent.classList.add('show-thankyou');
              if (formParent.closest('.form-modal')) {
                const formModalEle = formParent.closest('.form-modal');
                formModalEle.classList.add('show-thankyou');
              }
            } else {
              if (!extraValidateOtherField('#inquiry-steps-form', index)) {
                return;
              }

              toggleStep(index, false);
              if (index + 1 < allFormSteps.length) {
                toggleStep(index + 1, true);
              }
            }
            markCompleted(index);
          } catch (error) {
            console.error(error);
            formParent.classList.remove('show-loader');
            formParent.classList.add('show-error');
            formAlertError.classList.remove('hide');
            formAlertError.innerHTML = error.response.data.data.msg;
          }
        });
      });

    allForms.push(fv);
  });

  nextButton.addEventListener('click', moveNextStep);

  allStepIndicator.forEach((stepIndicator, index) => {
    stepIndicator.addEventListener('click', () => {
      allSteps.forEach((stepEle) => {
        if (stepEle.classList.contains('hide')) {
          stepEle.classList.remove('is-active');
        }
      });

      if (allFormSteps[index].classList.contains('hide')) {
        allFormSteps.forEach((item) => item.classList.toggle('remove'));
      }

      toggleStep(currentStepIndex, false);
      currentStepIndex = index;
      toggleStep(currentStepIndex, true);
      nextButton.innerHTML = currentStepIndex !== allFormSteps.length - 1 ? nextButtonText : submitButtonText;
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  ['inquiry-steps-form'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleStepForm(form, formAction, id);
    }
  });
});
